import { useState,useRef } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
import Alert from './Alert';
function App() {
  const [mode, setMode] = useState('light');
const [alert,setAlert]=useState(null);
const timeoutIdRef = useRef(null); // Use useRef to persist timeout ID

const showAlert=(message,type)=>{
setAlert({
  msg:message,
  type:type
});
if (timeoutIdRef.current) {
  clearTimeout(timeoutIdRef.current);
}

// Set a new timeout
timeoutIdRef.current = setTimeout(() => {
  setAlert(null);
}, 3000);
};

const clearAlert = () => {
if (timeoutIdRef.current) {
  clearTimeout(timeoutIdRef.current); // Clear the timeout if it exists
}
setAlert(null); // Set the alert state to null
};

  const toggleMode=()=>{
    if (mode==='light') {
      setMode('dark');
      document.body.style.backgroundColor='black';
      showAlert("Dark mode has been enabled","success");
    }
    else {
      setMode('light');
      document.body.style.backgroundColor='white';
      showAlert("Light mode has been enabled","success");

    }
  }

  
  return (
   <>
   <Navbar title="TextUtils" Aboutus="About TextUtils" mode={mode} toggleMode={toggleMode}/>
<Alert alert={alert} clearAlert={clearAlert}/>
<div className="container my3">
<TextForm showAlert={showAlert} heading="Enter the text to analyze below" mode={mode}/>
</div>
   </>
  );
}
export default App;